module.exports = __webpack_public_path__ + "static/Cooling_form_RU-1d01de48e0ddc788ce714ddae03c7021.pdf";